<template>
  <div class="flex flex_ju_sb videos-page" v-loading="loading">
    <template v-if="treeData.length">
      <!-- 左边列表 -->
      <div class="lefts">
        <div class="flex flex_a_c titles">
          <span class="title-line"></span>
          <span class="font_16 c_45 bold">监控列表</span>
        </div>
        <div class="video-trees">
          <el-tree
            ref="trees"
            :data="treeData"
            :props="defaultProps"
            highlight-current
            node-key="id"
            @node-click="handleNodeClickS"
          >
            <template #default="{ node, data }">
              <span class="custom-tree-node">
                <span v-if="data.videos && data.videos.length">{{
                  node.label
                }}</span>
                <span
                  v-else
                  :class="{
                    'video-choose-active': playIdList.indexOf(data.id) > -1,
                  }"
                  >{{ node.label }}</span
                >
              </span>
            </template>
          </el-tree>
        </div>
      </div>
      <!-- 中间播放 -->
      <div class="centers">
        <div class="videos" v-if="isShowVideos">
          <!-- <production-videos ref="hlsVideoPlayer" style="width: 100%; height: 100%"></production-videos> -->
          <!-- <videos-all-rtsp
						ref="hlsVideoPlayer"
						style="width: 100%; height: 100%"
						:layoutNum="layoutNum"
					></videos-all-rtsp> -->
          <videos-all-videos
            ref="hlsVideoPlayer"
            style="width: 100%; height: 100%"
            @changeVideoIndex="changeVideoIndex"
            @changeYtIndex="changeYtIndex"
          ></videos-all-videos>
        </div>
        <div class="videos flex flex_col flex_a_c flex_ju_c play-error" v-else>
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无播放视频</div>
        </div>
      </div>
      <!-- 右边云台控制 -->
      <div class="rights">
        <div class="flex flex_a_c titles">
          <span class="title-line"></span>
          <span class="font_16 c_45 bold">云台控制</span>
        </div>
        <div class="control-wrap">
          <div class="controls" v-if="chooseYtIndex > -1">
            <!-- 八个带小箭头的按钮，表示方向 -->
            <div
              v-for="index in 8"
              :key="index"
              class="control-jiantou"
              :class="'control-jiantou' + index"
              @click="toControl(index)"
            >
              <img
                :class="direct == index ? 'yt_chooses' : 'yt_choose'"
                src="../../assets/image/videos/yt_choose.png"
                alt=""
              />
              <img
                class="icon_jiantou"
                :class="'jiantou_icon' + index"
                src="../../assets/image/videos/icon1.png"
                alt=""
              />
            </div>
            <!-- 两个中间按钮表示放大缩小 -->
            <div class="control-center div_add" @click="toCenterControl('0')">
              <img
                class="addicon_n"
                src="../../assets/image/videos/yt_addn.png"
                alt=""
              />
              <img
                class="addicon_h"
                src="../../assets/image/videos/yt_addh.png"
                alt=""
              />
              <img
                class="addicon_hs"
                v-if="direct == '0'"
                src="../../assets/image/videos/yt_addh.png"
                alt=""
              />
            </div>
            <div class="control-center div_jian" @click="toCenterControl(13)">
              <img
                class="addicon_n"
                src="../../assets/image/videos/yt_jiann.png"
                alt=""
              />
              <img
                class="addicon_h"
                src="../../assets/image/videos/yt_jianh.png"
                alt=""
              />
              <img
                class="addicon_hs"
                v-if="direct == 13"
                src="../../assets/image/videos/yt_jianh.png"
                alt=""
              />
            </div>
          </div>
          <div class="flex flex_ju_c flex_wrap sets-wrap">
            <div
              class="t_c cursor set_div"
              v-for="(item, index) in setImgs"
              :key="index"
              :class="{ 'set-div-active': item.name == layoutName }"
              @click="changeLayout(item)"
            >
              <img class="set_icon" :src="item.icons" alt="" />
              <div class="font_14 set_name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="noSheBei" v-else>
      <img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
      <div class="table-emptyword">该网点暂无监控设备!</div>
    </div>
  </div>
</template>

<script>
/**
 * @description 远程诊断
 */
// import ProductionVideos from '../monitor/components/productionVideos.vue'
// import ProductionVideos from '../monitor/components/videosAllVideos.vue'
import videosAllRtsp from "../monitor/components/videosAllRtsp.vue";
import videosAllVideos from "../monitor/components/videosAllVideos.vue";
import bus from "@/api/bus";
export default {
  components: { videosAllRtsp, videosAllVideos },
  data() {
    return {
      // 左侧树形监控列表
      // treeData: [
      // 	{
      // 		label: '南阳淅川网点',
      // 		id: 1,
      // 		children: [
      // 			{
      // 				id: 11,
      // 				label: 'XX大棚一号',
      // 				children: [
      // 					{
      // 						id: 111,
      // 						isSelect: true,
      // 						label: '三级 1-1-1',
      // 					},
      // 				],
      // 			},
      // 			{
      // 				id: 12,
      // 				label: 'XX大棚二号',
      // 				children: [
      // 					{
      // 						id: 121,
      // 						isSelect: true,
      // 						label: '监控名称1',
      // 					},
      // 					{
      // 						id: 122,
      // 						isSelect: true,
      // 						label: '监控名称2',
      // 					},
      // 					{
      // 						id: 123,
      // 						isSelect: true,
      // 						label: '监控名称3',
      // 					},
      // 				],
      // 			},
      // 			{
      // 				label: 'XX大棚三号',
      // 				children: [
      // 					{
      // 						label: '三级 1-1-1',
      // 					},
      // 				],
      // 			},
      // 			{
      // 				label: 'XX大棚四号',
      // 				children: [
      // 					{
      // 						label: '三级 1-1-1',
      // 					},
      // 				],
      // 			},
      // 			{
      // 				label: 'XX大棚五号',
      // 				children: [
      // 					{
      // 						label: '三级 1-1-1',
      // 					},
      // 				],
      // 			},
      // 		],
      // 	},
      // ],
      treeData: [],
      defaultProps: {
        children: "videos",
        label: "vname",
      },
      // 视频页面的分栏设置
      setImgs: [
        {
          name: "1×1",
          nums: 1,
          icons: require("@/assets/image/videos/set_one.png"),
        },
        {
          name: "2×2",
          nums: 4,
          icons: require("@/assets/image/videos/set_two.png"),
        },
        {
          name: "1+5",
          nums: 6,
          icons: require("@/assets/image/videos/set_three.png"),
        },
        {
          name: "1+7",
          nums: 8,
          icons: require("@/assets/image/videos/set_four.png"),
        },
      ],
      layoutName: "1×1", // 分栏管理的选中值
      layoutNum: 1, // 分栏窗口数
      oldLayoutNum: 1, // 旧的分栏窗口数
      isShowVideos: false,
      playVurls: "", // 正在播放的视频
      playCodeList: [], // 选中的视频集合
      playUrlList: [], // 选中播放视频的地址
      playNameList: [], // 选中播放视频的名称
      playIdList: [],
      chooseIndex: 0, // 当前选中的第几个
      chooseMaxIndex: 0, // 分栏切换时，最多切换到了几个分栏
      chooseYtIndex: -1, // 云台控制选中值
      ytCode: "",
      videoUrls: process.env.VUE_APP_API_VIDEO_URL,
      loading: true,

      direct: "", // 云台控制的方向
      isStop: true, // 是否停止
    };
  },
  mounted() {
    // 获取数据
    this.loadData();
    // 点击关闭对应的视频
    bus.$on("closeCode", (val) => {
      let codeIndex = this.playCodeList.findIndex((item) => {
        return item == val;
      });
      if (codeIndex > -1) {
        if (this.playCodeList.length == 1) {
          this.playCodeList = [];
        } else {
          this.$set(this.playCodeList, codeIndex, "");
        }
      }
    });
  },
  destroyed() {
    bus.$off("closeCode");
  },
  methods: {
    // 获取数据
    loadData() {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        orgId: userInfos.orgId,
      };
      this.$http
        .getAction(this.$api.findOrgVideoTree, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            let newTree = [];
            let itemObj = {};
            if (datas && datas.length) {
              datas.forEach((item) => {
                itemObj = JSON.parse(JSON.stringify(item));
                this.$set(itemObj, "vname", item.orgName);
                newTree.push(itemObj);
              });
              this.$nextTick(() => {
                this.treeData = newTree || [];
              });
            } else {
              this.treeData = [];
            }
          } else {
            this.treeData = [];
          }
        })
        .catch(() => {
          this.treeData = [];
        })
        .finally((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    // 监控列表数被点击
    handleNodeClick(data) {
      // 说明点击的是第一层，拦截点击事件
      if (data.videos && data.videos.length) return;
      // 点击数据的id
      let ids = this.$refs.trees.getCurrentKey();

      // 点击的数据
      let nodes = this.$refs.trees.getCurrentNode();
      console.log(nodes);
      // 获取点击数据的视频地址
      let vurl = nodes.vurl || "";
      let vid = nodes.id || "";
      let vcode = nodes.vcode || "";
      let vname = nodes.vname || ""; // 视频名称
      this.isShowVideos = true;
      // 判断视频为空的情况
      if (vurl && vurl != "") {
        this.$nextTick(() => {
          // 视频已经被选中了
          if (this.playCodeList.indexOf(vcode) > -1) {
            this.$message("该视频已选中播放", "error");
            return;
          } else {
            // 没有被选中的情况下
            // 是一栏
            if (this.layoutNum == 1) {
              // this.playCodeList = []
              // 没有进行播放中的视频，直接赋值播放
              if (!this.playCodeList.length) {
                console.log("添加1");
                this.$refs.hlsVideoPlayer.handelVideoUrl(vcode, vurl, vname);
                // 把当前的链接放进去
                this.playCodeList.push(vcode);
                this.playUrlList.push(vurl);
                this.playNameList.push(vname);
                this.playIdList.push(vid);
              } else {
                console.log("编辑one");
                // 如果已经有正在播放的视频，进行视频的替换
                this.playCodeList = [vcode];
                this.playUrlList = [vurl];
                this.playNameList = [vname];
                this.playIdList = [vid];
                this.$refs.hlsVideoPlayer.editUrl(vcode, vurl, vname, 0);
              }
            } else {
              console.log("else");
              // 如果不是一栏
              // 如果还有播放窗口---直接添加进去
              if (this.layoutNum > this.playCodeList.length) {
                console.log("bigss");
                // 选择的是下一个
                if (this.chooseIndex == this.playCodeList.length) {
                  console.log("等于");
                  // 判断选中的这个里面是否已经有值
                  // 未被填充选择过的最大的，大于目前选中的，即当前选中的已经被填充过了，进行编辑的操作
                  if (this.chooseMaxIndex > this.chooseIndex) {
                    console.log("更改");
                    this.$set(this.playCodeList, this.chooseIndex, vcode);
                    this.$set(this.playUrlList, this.chooseIndex, vurl);
                    this.$set(this.playNameList, this.chooseIndex, vname);
                    this.$set(this.playIdList, this.chooseIndex, vid);
                    // this.$refs.hlsVideoPlayer.handelVideoUrl2(vcode, vurl, vname, this.chooseIndex)
                    this.$refs.hlsVideoPlayer.handelVideoUrl2(
                      vcode,
                      vurl,
                      vname,
                      this.chooseIndex
                    );
                  } else {
                    console.log("添加");
                    // 否则直接添加
                    this.playCodeList.push(vcode);
                    this.playUrlList.push(vurl);
                    this.playNameList.push(vname);
                    this.playIdList.push(vid);
                    this.$refs.hlsVideoPlayer.handelVideoUrl(
                      vcode,
                      vurl,
                      vname
                    );
                  }
                } else {
                  console.log("更改2");
                  this.$set(this.playCodeList, this.chooseIndex, vcode);
                  this.$set(this.playUrlList, this.chooseIndex, vurl);
                  this.$set(this.playNameList, this.chooseIndex, vname);
                  this.$set(this.playIdList, this.chooseIndex, vid);
                  this.$refs.hlsVideoPlayer.editUrl(
                    vcode,
                    vurl,
                    vname,
                    this.chooseIndex
                  );
                }
              } else {
                console.log("相等");
                this.$set(this.playCodeList, this.chooseIndex, vcode);
                this.$set(this.playUrlList, this.chooseIndex, vurl);
                this.$set(this.playNameList, this.chooseIndex, vname);
                this.$set(this.playIdList, this.chooseIndex, vid);
                this.$refs.hlsVideoPlayer.editUrl(
                  vcode,
                  vurl,
                  vname,
                  this.chooseIndex
                );
                // // 如果没有了----排查是否有已删除的视频空位，按index顺序添加
                // let emptyIndex = this.playCodeList.findIndex((item) => {
                // 	return item == ''
                // })
                // // 判断里面是否有已经删除的视频
                // if (emptyIndex > -1) {
                // 	this.$set(this.playCodeList, emptyIndex, vcode)
                // 	this.$set(this.playUrlList, emptyIndex, vurl)
                // 	this.$refs.hlsVideoPlayer.editUrl(vcode, vurl, emptyIndex)
                // } else {
                // 	this.$message('视频选中已满,请先关闭视频', 'error')
                // }
              }
            }

            this.$refs.hlsVideoPlayer.thisCodeLength = this.playCodeList.length;
          }
          // if (this.playVurls && this.playVurls != '') {
          // 	this.$refs.hlsVideoPlayer.editUrl(vurl)
          // } else {

          // }
          // this.playVurls = vurl
        });
      } else {
        this.$message("暂无视频数据", "error");
      }
    },
    handleNodeClickS(data) {
      // 说明点击的是第一层，拦截点击事件
      if (data.videos && data.videos.length) return;
      // 点击的数据
      let nodes = this.$refs.trees.getCurrentNode();
      // 获取点击数据的视频地址
      let vurl = nodes.vurl || "";
      let vid = nodes.id || "";
      let vcode = nodes.vcode || "";
      let vname = nodes.vname || ""; // 视频名称

      // TODO 方法一：直接在列表中添加设备类型的字段
      let vtype = nodes.vType || "0"; // 设备类型  监控类型 0 未知 1 枪机 2 球机 3 半球

      // 判断视频为空
      if (vurl && vurl != "" && vurl != " ") {
        // 视频显示
        this.isShowVideos = true;

        this.$nextTick(() => {
          // 视频已选中播放
          if (this.playIdList.indexOf(vid) > -1) {
            this.$message("该视频已选中播放", "error");
            return;
          }
          // 判断分栏情况
          // 只有一栏 ==== 没有数据进行添加，有数据进行编辑替换
          if (this.layoutNum == 1) {
            if (!this.playCodeList.length) {
              console.log("添加1");
              this.$refs.hlsVideoPlayer.handelVideoUrl(
                vcode,
                vurl,
                vname,
                vtype
              );
              // 把当前的链接放进去
              this.playCodeList.push(vcode);
              this.playUrlList.push(vurl);
              this.playNameList.push(vname);
              this.playIdList.push(vid);
            } else {
              console.log("编辑one");
              // 如果已经有正在播放的视频，进行视频的替换
              this.playCodeList = [vcode];
              this.playUrlList = [vurl];
              this.playNameList = [vname];
              this.playIdList = [vid];
              this.$refs.hlsVideoPlayer.editUrl(vcode, vurl, vname, 0, vtype);
            }
          } else {
            console.log("多窗口");
            // 多栏情况
            // 还有播放窗口：当选选中窗口数大于已选中播放的列表
            if (this.layoutNum > this.playCodeList.length) {
              // 选中切换的是正在播放的，直接编辑替换
              if (this.chooseIndex < this.playCodeList.length) {
                console.log("判断编辑3");
                this.$refs.hlsVideoPlayer.editIsPlay(this.chooseIndex, true);
                this.$set(this.playCodeList, this.chooseIndex, vcode);
                this.$set(this.playUrlList, this.chooseIndex, vurl);
                this.$set(this.playNameList, this.chooseIndex, vname);
                this.$set(this.playIdList, this.chooseIndex, vid);
                this.$refs.hlsVideoPlayer.resetEdit(
                  vcode,
                  vurl,
                  vname,
                  this.chooseIndex,
                  vtype
                );
              } else {
                // 判断是否是已经添加过的
                // 没有添加过，直接添加
                if (this.chooseIndex > this.chooseMaxIndex) {
                  console.log("添加more");
                  this.playCodeList.push(vcode);
                  this.playUrlList.push(vurl);
                  this.playNameList.push(vname);
                  this.playIdList.push(vid);
                  this.$refs.hlsVideoPlayer.handelVideoUrl(
                    vcode,
                    vurl,
                    vname,
                    vtype
                  );
                } else {
                  console.log("判断编辑1");
                  this.$refs.hlsVideoPlayer.editIsPlay(this.chooseIndex, true);
                  this.$set(this.playCodeList, this.chooseIndex, vcode);
                  this.$set(this.playUrlList, this.chooseIndex, vurl);
                  this.$set(this.playNameList, this.chooseIndex, vname);
                  this.$set(this.playIdList, this.chooseIndex, vid);
                  this.$refs.hlsVideoPlayer.resetEdit(
                    vcode,
                    vurl,
                    vname,
                    this.chooseIndex,
                    vtype
                  );
                }
              }
            } else {
              // 添加到最后一个的时候，判断是否是从少窗口切换来的
              console.log("oldLayoutNum:" + this.oldLayoutNum);
              console.log("判断编辑2");
              this.$refs.hlsVideoPlayer.editIsPlay(this.chooseIndex, true);
              this.$set(this.playCodeList, this.chooseIndex, vcode);
              this.$set(this.playUrlList, this.chooseIndex, vurl);
              this.$set(this.playNameList, this.chooseIndex, vname);
              this.$set(this.playIdList, this.chooseIndex, vid);
              this.$refs.hlsVideoPlayer.resetEdit(
                vcode,
                vurl,
                vname,
                this.chooseIndex,
                vtype
              );
            }

            this.$refs.hlsVideoPlayer.thisCodeLength = this.playCodeList.length;
          }
        });
      } else {
        this.$message("暂无视频数据", "error");
        if (!this.playCodeList.length) {
          this.isShowVideos = false;
        }
      }
    },
    changeVideoIndex({ chooseIndex, maxIndex }) {
      this.chooseIndex = chooseIndex;
      if (this.chooseMaxIndex < maxIndex) {
        this.chooseMaxIndex = maxIndex;
      }
    },
    // 云台控制选中的改变
    changeYtIndex({ val }) {
      if (this.chooseYtIndex == val) return;
      this.chooseYtIndex = val;
      if (val == -1) {
        this.ytCode = "";
      } else {
        // 获取云台控制视频的code即传参id值
        this.ytCode = this.playCodeList[val];
      }
    },
    // TODO 分栏管理选中改变
    changeLayout({ name, nums }) {
      // this.$message('该功能暂不可用', 'warn')
      // return
      // 当前分栏重复选择
      if (this.layoutName == name) return;
      // 没有选中视频的时候，不允许切换分栏
      if (!this.playCodeList.length) return;
      // 赋值上一个分栏窗口数，用作对比
      this.oldLayoutNum = this.layoutNum;
      console.log(this.oldLayoutNum);
      // 赋值页面的窗口数
      this.$refs.hlsVideoPlayer.layoutNum = nums;

      this.$refs.hlsVideoPlayer.changeYtChoose();

      let hadCodeList = [];
      let hadUrlList = [];
      let hadNameList = [];
      let hadIdList = [];

      // TODO 暂时没必要进行，无连接的视频添加时已进行了判断处理，此步骤无用
      this.playCodeList.forEach((item, index) => {
        // 剔除为空的情况，进行数据重新添加
        if (item != "") {
          hadCodeList.push(item);
          hadUrlList.push(this.playUrlList[index]);
          hadNameList.push(this.playNameList[index]);
          hadIdList.push(this.playIdList[index]);
        }
      });

      // 如果选中切换的窗口屏幕小于当前展示的屏幕数，直接替换已经存在的，把多余的隐藏播放
      // 说明：为什么是隐藏而不是直接销毁删除
      // 答：直接删除会造成再次赋值视频无法播放的问题
      if (nums < this.layoutNum) {
        console.log("small");
        // 截取当前展示的前几个
        hadCodeList = hadCodeList.slice(0, nums);
        hadUrlList = hadUrlList.slice(0, nums);
        hadNameList = hadNameList.slice(0, nums);
        hadIdList = hadIdList.slice(0, nums);
        // 赋值当前
        this.playCodeList = [...hadCodeList];
        this.playUrlList = [...hadUrlList];
        this.playNameList = [...hadNameList];
        this.playIdList = [...hadIdList];
        this.$refs.hlsVideoPlayer.thisCodeLength = hadCodeList.length;

        //
        // hadCodeList.forEach((item, index) => {
        // 	this.$refs.hlsVideoPlayer.resetUrl(item, hadUrlList[index], index)
        // })
        setTimeout(() => {
          let chooseMaxIndex = this.chooseMaxIndex;
          chooseMaxIndex = chooseMaxIndex + 1;
          if (
            chooseMaxIndex == 3 ||
            chooseMaxIndex == 5 ||
            chooseMaxIndex == 7
          ) {
            chooseMaxIndex = chooseMaxIndex + 1;
          } else {
            chooseMaxIndex = chooseMaxIndex;
          }
          for (let i = 0; i < chooseMaxIndex; i++) {
            console.log(i);
            if (hadCodeList[i] && hadCodeList[i] != "") {
              // 修改赋值
              this.$refs.hlsVideoPlayer.editIsPlay(i, true);
            } else {
              this.$refs.hlsVideoPlayer.editIsPlay(i, false);
            }
          }
          // 	// hadCodeList.forEach((item, index) => {
          // 	// 	this.$refs.hlsVideoPlayer.handelVideoUrl(item, hadUrlList[index], hadNameList[index], index)
          // 	// })
        }, 400);

        // if (hadCodeList.length > nums) {
        // 	this.$message('请先关闭其它视频', 'warn')
        // 	return
        // } else {
        // 	this.playCodeList = hadCodeList
        // 	this.playUrlList = hadUrlList
        // 	hadCodeList.forEach((item, index) => {
        // 		this.$refs.hlsVideoPlayer.editUrl(item, hadUrlList[index], index)
        // 	})
        // }
      } else {
        this.playCodeList = hadCodeList;
        this.playUrlList = hadUrlList;
        this.playNameList = hadNameList;
        this.playIdList = hadIdList;
        this.$refs.hlsVideoPlayer.thisCodeLength = hadCodeList.length;

        for (let i = 0; i < hadCodeList.length; i++) {
          console.log(i);
          this.$refs.hlsVideoPlayer.editIsPlay(i, true);
        }
        // setTimeout(() => {
        // 	for (const i in hadCodeList) {
        // 		this.$refs.hlsVideoPlayer.editUrl(hadCodeList[i], hadUrlList[i], hadNameList[i], i)
        // 	}
        // }, 400)

        // hadCodeList.forEach((item, index) => {
        // 	this.$refs.hlsVideoPlayer.resetUrl(item, hadUrlList[index], index)
        // })
      }
      if (nums == this.playCodeList.length) {
        this.$refs.hlsVideoPlayer.chooseIndex = this.playCodeList.length - 1;
        this.chooseIndex = this.playCodeList.length - 1;
      } else {
        this.$refs.hlsVideoPlayer.chooseIndex = this.playCodeList.length;
        this.chooseIndex = this.playCodeList.length;
      }

      this.layoutName = name;
      this.layoutNum = nums;
    },
    // 方向改变
    toControl(direct) {
      // 是停止状态，可以进行操作
      // 不存在，直接开始
      if (this.direct == "") {
        let params = {
          cameraId: this.ytCode,
          direct: direct,
          step: 30,
          stop: false,
        };
        this.direct = direct;
        this.$http
          .postAction(this.$api.ptzCtrl, params, this.videoUrls)
          .then((res) => {});
      } else if (this.direct == direct) {
        // 二次点击-停止
        let params = {
          cameraId: this.ytCode,
          direct: direct,
          step: 30,
          stop: true,
        };
        this.direct = "";
        this.$http
          .postAction(this.$api.ptzCtrl, params, this.videoUrls)
          .then((res) => {});
      } else {
        let paths = "";
        if (this.direct == "0" || this.direct == "13") {
          paths = this.$api.ptzOperationCtrl;
        } else {
          paths = this.$api.ptzCtrl;
        }
        // 其它操作
        // 先调取停止，然后再操控
        let params = {
          cameraId: this.ytCode,
          direct: Number(this.direct) == 13 ? 3 : Number(this.direct),
          step: 30,
          stop: true,
        };
        let startParams = {
          cameraId: this.ytCode,
          direct: direct,
          step: 30,
          stop: false,
        };
        this.$http.postAction(paths, params, this.videoUrls).then((res) => {
          console.log(res);
          if (res.msg == "success") {
            // 调开始
            this.direct = direct;
            this.$http
              .postAction(this.$api.ptzCtrl, startParams, this.videoUrls)
              .then((res) => {});
          }
        });
      }
    },
    // 视频放大缩小
    toCenterControl(direct) {
      console.log(this.direct);
      let directs = direct == "13" ? "3" : direct;
      if (this.direct == "") {
        let params = {
          cameraId: this.ytCode,
          direct: Number(directs),
          step: 30,
          stop: false,
        };
        this.direct = direct;
        this.$http
          .postAction(this.$api.ptzOperationCtrl, params, this.videoUrls)
          .then((res) => {});
      } else if (this.direct == direct) {
        // 二次点击-停止
        let params = {
          cameraId: this.ytCode,
          direct: Number(directs),
          step: 30,
          stop: true,
        };
        this.direct = "";
        this.$http
          .postAction(this.$api.ptzOperationCtrl, params, this.videoUrls)
          .then((res) => {});
      } else {
        let paths = "";
        if (this.direct == "0" || this.direct == "13") {
          paths = this.$api.ptzOperationCtrl;
        } else {
          paths = this.$api.ptzCtrl;
        }
        // 其它操作
        // 先调取停止，然后再操控
        let params = {
          cameraId: this.ytCode,
          direct: Number(this.direct) == 13 ? 3 : Number(this.direct),
          step: 30,
          stop: true,
        };
        let startParams = {
          cameraId: this.ytCode,
          direct: Number(directs),
          step: 30,
          stop: false,
        };
        this.$http.postAction(paths, params, this.videoUrls).then((res) => {
          if (res.msg == "success") {
            // 调开始
            this.direct = direct;
            const { data: ress } = this.$http.postAction(
              this.$api.ptzOperationCtrl,
              startParams,
              this.videoUrls
            );
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.videos-page {
  height: 100%;
  text-align: left;
  .titles {
    padding: 0.25rem 0.28rem;
    .title-line {
      display: inline-block;
      width: 5px;
      height: 18px;
      background: #459e8c;
      margin-right: 0.19rem;
    }
  }
  .lefts {
    width: 12.21vw;
    height: 100%;
    min-height: 580px;
    background: #ffffff;
    border-radius: 15px;
    .titles {
      border-bottom: 1px solid #f1f1f1;
    }
    .video-choose-active {
      color: #2daea9;
    }
  }
  .centers {
    width: 58.3vw;
    height: 100%;
    min-height: 580px;
    background: #ffffff;
    border-radius: 15px;
    .videos {
      width: 13.49rem;
      // height: 9.54rem;
      height: 95.5%;
      margin: 0.22rem auto 0;
    }
    .play-error {
      .table-noimg {
        width: 3.13rem;
      }
      .table-emptyword {
        margin-top: 0.75rem;
        font-size: 0.2rem;
        color: #797979;
      }
    }
  }
  .rights {
    // width: 2.92rem;
    width: 12.2vw;
    height: 100%;
    min-height: 580px;
    background: #ffffff;
    border-radius: 15px;
    .titles {
      border-bottom: 1px solid #f1f1f1;
    }
    .control-wrap {
      margin-top: 0.19rem;
    }
    // 云台控制按钮模块
    .controls {
      width: 2.35rem;
      height: 2.35rem;
      // background: rgba(231, 241, 243, 0.79);
      border-radius: 50%;
      margin: auto;
      background: url("../../assets/image/videos/yt_bg.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .control-jiantou {
        position: absolute;
        width: 0.86rem;
        height: 0.42rem;
        cursor: pointer;
        &:hover {
          .yt_choose {
            display: block;
          }
        }
        .yt_choose {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 3;
          display: none;
        }
        .yt_chooses {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 3;
        }
        .icon_jiantou {
          width: 0.21rem;
          position: absolute;
          z-index: 4;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      // 各个方向的箭头样式
      // 上
      .control-jiantou1 {
        top: 0.13rem;
        left: 0.74rem;
      }
      // 下
      .control-jiantou2 {
        bottom: 0.15rem;
        left: 0.74rem;
        transform: rotate(180deg);
      }
      // 左
      .control-jiantou3 {
        top: 0.95rem;
        left: -0.085rem;
        transform: rotate(-90deg);
      }
      // 右
      .control-jiantou4 {
        top: 0.94rem;
        right: -0.06rem;
        transform: rotate(90deg);
      }
      // 左上
      .control-jiantou5 {
        top: 0.36rem;
        left: 0.16rem;
        transform: rotate(-43deg);
      }
      // 左下
      .control-jiantou6 {
        bottom: 0.39rem;
        left: 0.16rem;
        transform: rotate(-134deg);
      }
      // 右上
      .control-jiantou7 {
        top: 0.36rem;
        right: 0.18rem;
        transform: rotate(46deg);
      }
      // 右下
      .control-jiantou8 {
        bottom: 0.4rem;
        right: 0.17rem;
        transform: rotate(134deg);
      }
      // 中间的加减
      .control-center {
        position: absolute;
        width: 1.13rem;
        height: 0.54rem;
        left: 0.61rem;
        cursor: pointer;
        &:hover {
          .addicon_h {
            display: block;
          }
        }
        &.div_add {
          top: 0.6rem;
        }
        &.div_jian {
          bottom: 0.6rem;
        }
        .addicon_n {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 3;
        }
        .addicon_h {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 4;
          display: none;
          top: 0;
          left: 0;
        }
        .addicon_hs {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 4;
          top: 0;
          left: 0;
        }
      }
    }
    .sets-wrap {
      margin-top: 0.04rem;
      .set_div {
        width: 0.85rem;
        padding: 0.14rem 0 0.09rem;
        margin-top: 0.25rem;
        &:nth-child(2n) {
          margin-left: 0.42rem;
        }
        &:hover {
          background-color: #e7f1f3;
        }
      }
      .set-div-active {
        background-color: #e7f1f3;
      }
      .set_name {
        color: #2daea9;
        margin-top: 0.14rem;
      }
    }
  }
}
.noSheBei {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .table-emptyword {
    margin-top: 0.75rem;
    color: #797979;
    font-size: 0.17rem;
  }
}
</style>
<style lang="scss">
.video-trees {
  height: 91%;
  overflow-y: scroll;
  .el-tree-node__content {
    height: 0.44rem;
    color: #454545;
    font-size: 0.17rem;
  }
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: #e7f1f3 !important;
  }
}
</style>
